import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useFetchModelsQuery,
  usePostEquipmentMutation,
} from "../../../../store";
import { setEquipment } from "../../../../store/slices/applicationManagement/managementSlice";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { EQUIPMENT_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { useFormik } from "formik";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import Modal from "@mui/material/Modal";
import equipmentValidation from "../utils/equipmentValidation";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Loading from "../../../../components/shared/Loading";
import CustomSelect from "../../../../components/shared/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

const EquipmentForm = () => {
  const dispatch = useDispatch();
  const { equipmentDialogOpen } = useSelector((state) => state.dialogSlice);
  const { equipment } = useSelector((state) => state.managementSlice);
  const { data: models, isLoading: modelsLoading } = useFetchModelsQuery();

  const [postEquipment, { isLoading }] = usePostEquipmentMutation();
  const handleClose = () => {
    dispatch(setEquipment(null));
    dispatch(closeDialog(EQUIPMENT_DIALOG));
  };
  const formik = useFormik({
    initialValues: {
      id: equipment?.id ?? 0,
      modelId: equipment?.modelId ?? 0,
      serialNumber: equipment?.serialNumber ?? "",
      serviceTag: equipment?.serviceTag ?? "",
    },
    validationSchema: equipmentValidation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postEquipment({
          id: formik.values.id,
          modelId: formik.values.modelId,
          serialNumber: formik.values.serialNumber,
          serviceTag: formik.values.serviceTag,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Ekipman Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  if (modelsLoading) return <Loading isLoading={modelsLoading} />;
  return (
    <Modal
      open={equipmentDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          Ekipman Kaydet
        </Typography>
        <FormControl
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          error={formik.touched.modelId && Boolean(formik.errors.modelId)}
        >
          <InputLabel id="modelId-label">Model</InputLabel>
          <CustomSelect
            data={
              models?.data.map((equipment) => ({
                id: equipment.id,
                name: `${equipment.categoryName}-${equipment.brandName}-${equipment.name}`,
              })) || []
            }
            id="modelId"
            value={formik.values.modelId}
            handleChange={formik.handleChange}
          />
          {formik.touched.modelId && (
            <FormHelperText>{formik.errors.modelId}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          error={formik.touched.count && Boolean(formik.errors.count)}
        >
          <TextField
            label="Seri Numarası"
            name="serialNumber"
            value={formik.values.serialNumber}
            onChange={formik.handleChange}
            error={
              formik.touched.serialNumber && Boolean(formik.errors.serialNumber)
            }
            helperText={
              formik.touched.serialNumber && formik.errors.serialNumber
            }
            type="text"
            fullWidth
            autoFocus
          />
        </FormControl>
        <FormControl
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          error={formik.touched.count && Boolean(formik.errors.count)}
        >
          <TextField
            label="Servis Etiketi"
            name="serviceTag"
            value={formik.values.serviceTag}
            onChange={formik.handleChange}
            error={
              formik.touched.serviceTag && Boolean(formik.errors.serviceTag)
            }
            helperText={formik.touched.serviceTag && formik.errors.serviceTag}
            type="text"
            fullWidth
            autoFocus
          />
        </FormControl>
        <Stack spacing={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default EquipmentForm;
